import React from "react";

const Prods = () => {
  return (
    <div
      className="bg-white hover:shadow-2xl w-[300px] h-[400px] rounded-2xl overflow-hidden transition-all duration-150
              border"
    >
      <img
        src="/Images/popularProduct.svg"
        alt="chair"
        className="w-full h-64 object-cover"
        width="800"
        height="100"
      />
      <div className="text-lg  px-2 mt-3 h-40 ">
        <p className="font-bold">Dainty Name Necklace with Birth Flower a...</p>
        <p>
          <i className="bi bi-star-fill space-x-2 text-[#FF4C3B]"></i>
          <i className="bi bi-star-fill space-x-2 text-[#FF4C3B]"></i>
          <i className="bi bi-star-fill space-x-2 text-[#FF4C3B]"></i>
          <i className="bi bi-star-fill space-x-2 text-[#FF4C3B]"></i>
          <i className="bi bi-star-fill space-x-2 text-[#FF4C3B]"></i>
        </p>
        <p>NGN 2000</p>
      </div>
    </div>
  );
};

export default Prods;
